import React, {useEffect, useState} from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography, Divider, TextField, InputAdornment, DialogActions, MenuItem, FormControlLabel, Checkbox
} from '@mui/material';
import AddBox from '@mui/icons-material/AddBox';
import CloseIcon from '@mui/icons-material/Close';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {EditOutlined} from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import {useSnackbar} from "notistack";
import LoadingButton from "../../../components/elements/LoadingButton";
import validator from "validator";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import RayaField from "../../../components/elements/fields/RayaField";
import {Pencil} from "lucide-react";
import SingleImageChooser from "../../fileManager/Components/SingleImageChooser";
import ShopAdminChooser from "../shops/components/ShopAdminChooser";
import UserChooserForCharity from "./components/UserChooserForCharity";

const MakeCharityButton = ({ disabled, classes,item_id,industry_id,reload }) => {
    const [open, setOpen] = useState(false);
    const navigation = useNavigate();
    const { t } = useTranslation();

    const initFields = {
        name: '',
        activity_field: '',
        description: '',
    };
    const [fields, setFields] = useState(initFields);
    const [data, setData] = useState(null);
    const [errors, setErrors] = useState({});
    const [file, setFile] = useState(null);
    const [user_id, setUserId] = useState(null);

    const [submitLoading, setSubmitLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const loginToken = localStorage.getItem('ACT');
    const loadData = async () =>{
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        }
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/charities/get/${item_id}`,config)
            .then(response => {
                let fields = {
                    name: response.data.name,
                    activity_field: response.data.activity_field,
                    description: response.data.description,
                }
                setUserId(response.data.user_id)

                setFields(fields);
                setFile(response.data.file);
                setData(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false);
            });
    }
    const resetFields = () => {
        setFields(initFields);
        setFile(null);
    }
    useEffect(() => {
        if(!!item_id && !!open)  loadData();
    }, [item_id,open]);
    useEffect(() => {

    }, [industry_id]);
    
    const handleChange = (e) => {
        let { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const handleField = (input,val) => {
        setFields((prevFields) => ({ ...prevFields, [input] : val }));
        setErrors((prevErrors) => ({ ...prevErrors, [input]: '' }));
    };

    const closeDialog = () => {
        setOpen(false);
        if(!item_id){
            setTimeout(() => {
                resetFields();
            }, 300);
        }
    }
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};

        // Validation for full_name
        if (validator.isEmpty(fields.name)) {
            formIsValid = false;
            newErrors.name = t('emptyField');
        }
        if(!user_id){
            formIsValid = false;
            newErrors.user = t('emptyField');
        }
        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();

        data.append('name', fields.name);
        data.append('activity_field', fields.activity_field);
        data.append('description', fields.description);
        if(!!item_id){
            data.append('item_id', item_id);
        }
        if(!!file){
            data.append('file_id', file.id);
        }
        if(!!user_id){
            data.append('user_id', user_id);
        }
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/charities/make`, data, config);
            reload();
            setSubmitLoading(false);
            closeDialog();
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });

        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            if(error.response.status === 403){
                enqueueSnackbar(t('duplicateItemName'), { variant: 'warning' });
            }else{
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };
    return (
        <>
            {
                !item_id ?
                    <Button
                        disabled={disabled}
                        variant={!!item_id ? "contained" : "contained"}
                        color="secondary"
                        startIcon={!!item_id ? <Pencil className="lucide-icon-secondary btn"/> : <AddBox/>}

                        onClick={() => setOpen(!open)}
                        //className={!!item_id ? "editItemBtn" : "addItemBtn"}
                    >
                        {t(!!item_id ? "editCharity" : 'addCharity')}
                    </Button>
                    :
                    <Button
                        disabled={disabled}
                        variant="outlined"
                        color="secondary"
                        onClick={() => setOpen(!open)}
                        startIcon={!!item_id ? <Pencil className="lucide-icon-secondary btn"/> : <AddBox/>}
                    >
                        {t(!!item_id ? "edit" : 'editCharity')}
                    </Button>
             }


            <Dialog
                fullWidth
                maxWidth={'sm'}
                open={open}
                onClose={() => closeDialog()}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    {t(!!item_id ? "editCharity" : 'addCharity')}
                    <IconButton aria-label="close" className={classes.dialogClose} onClick={() => closeDialog()}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <Divider/>
                <DialogContent className="dialog-add-match">
                    <Grid container spacing={2}>
                        {
                            !!loading ?
                                <Grid item size={12}>
                                    <AppCardLoaderFields height={300}/>
                                </Grid>
                                    :
                                <>
                                    <Grid item size={12} className="imageChooserHolder">
                                        <SingleImageChooser
                                            primary
                                            onChange={(file) => setFile(file)}
                                            initial={file}
                                            width={150}
                                        />
                                    </Grid>
                                    <Grid item size={{xs: 12}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('charityName')}
                                            name="name"
                                            value={fields.name}
                                            onChange={handleChange}
                                            error={!!errors.name}
                                            helperText={errors.name}
                                        />
                                    </Grid>
                                    <Grid item size={{xs: 12}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            multiline
                                            rows='2'
                                            label={t('charityActivityField')}
                                            name="activity_field"
                                            value={fields.activity_field}
                                            onChange={handleChange}
                                            error={!!errors.activity_field}
                                            helperText={errors.activity_field}
                                        />
                                    </Grid>
                                    <Grid item size={{xs: 12}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            multiline
                                            rows='4'
                                            label={t('description')}
                                            placeholder={t('charityDescriptionDesc')}
                                            name="description"
                                            value={fields.description}
                                            onChange={handleChange}
                                            error={!!errors.description}
                                            helperText={errors.description}
                                        />
                                    </Grid>
                                    <Grid item size={{xs:12}}>
                                        <UserChooserForCharity
                                            charity_id={item_id}
                                            handleRes={(user) => !!user && setUserId(user.id)}
                                            default_id={user_id}
                                            error={errors['user']}
                                            disabled={!!item_id}
                                        />
                                    </Grid>
                                </>
                        }

                    </Grid>
                </DialogContent>
                <DialogActions style={{display:"flex",justifyContent:"center"}}>
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            loading={submitLoading}
                        >
                            {t('setDetails')}
                        </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default withStyles(Styles)(MakeCharityButton);
